export default {
  get() {
    let history = window.localStorage.getItem('history')

    return history ? JSON.parse(history) : []
  },
  set(history) {
    window.localStorage.setItem('history', JSON.stringify(history))
  },
  remove() {
    window.localStorage.removeItem('history')
  }
}
